import { UploadDocument } from '@data-access/documents/types';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  entityConfig,
  setAllEntities,
  updateEntity,
  withEntities,
} from '@ngrx/signals/entities';

const _UploadDocumentEntityConfig = () =>
  entityConfig({
    collection: '_uploadDocument',
    entity: type<UploadDocument>(),
    selectId: (entity) => entity.id,
  });

export const withUploadDocumentEntities = () => {
  return signalStoreFeature(
    withEntities(_UploadDocumentEntityConfig()),
    withMethods(({ ...store }) => ({
      loadUploadDocument: (data: UploadDocument[]) => {
        return patchState(
          store,
          setAllEntities(data, _UploadDocumentEntityConfig()),
        );
      },

      applyDocumentGridUpdate: (data: UploadDocument) => {
        return patchState(
          store,
          updateEntity(
            { id: data.id, changes: data },
            _UploadDocumentEntityConfig(),
          ),
        );
      },
    })),
  );
};
